<template>
  <v-main>
    <section class="title">
      <Title :title="title" :img="img"></Title>
    </section>
    <v-sheet color="backgroundGrayColor" height="auto" style="border: solid rgb(220, 220, 220);">
      <v-container class="mx-auto" style="max-width: 1100px;">
        <!--給湯室-->
        <v-container>
          <v-row justify="start">
            <p class="text-h5 my-6">給湯室について</p>
          </v-row>
          <!--冷蔵庫-->
          <v-row justify="center" class="my-8">
            <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-responsive min-height="150">
                  <v-expansion-panel-header class="text-h5 fill-height">
                    <v-col cols="4" align="center">
                      <v-img class="mx-8" src="@/assets/refrigerator.jpg" max-width="100">
                      </v-img>
                    </v-col>
                    <v-col cols="8">
                      冷蔵庫利用ルール
                    </v-col>
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="text-body-1 py-6">
                  <ul class="explanation__list">
                    <li v-for="(item, index) in refrigeratorUsage" :key="index"
                        class="px-4 mb-6"
                        v-html="item"
                    >
                    </li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
          <!--ゴミ捨て場-->
          <v-row justify="center" class="my-8">
            <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-responsive min-height="150">
                  <v-expansion-panel-header class="text-h5 fill-height">
                    <v-col cols="4" align="center">
                      <v-img class="mx-8" src="@/assets/dumpSite.jpg" max-width="100"></v-img>
                    </v-col>
                    <v-col cols="8">
                      ゴミ捨て場利用ルール
                    </v-col>
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="text-body-1 py-6">
                  <ul class="explanation__list">
                    <v-img src="@/assets/rule1.jpg" max-width="400" class="mx-8 mb-6 dumpSite__img"></v-img>
                    <li v-for="(item, index) in dumpSiteUsage" :key="index"
                        class="px-4 mb-6"
                        v-html="item"
                    >
                    </li>
                  </ul>
                  <v-col class="text-body-2 px-12 pt-6">
                    <v-sheet class="px-6 py-6" color="rgba(245, 245, 245, 1)">
                      過去以下のような事例があったため、<span class="d-inline-block">このようなルールを作りました。</span><span class="d-inline-block">みんなできれいなオフィスを維持できるよう協力お願いします。</span>
                      <ul class="pt-12">
                        <li v-for="(item, index) in dumpSiteCautionUsage" :key="index"
                            class="px-4 mb-3"
                            v-html="item"
                        >
                        </li>
                      </ul>
                    </v-sheet>
                  </v-col>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
          <!--その他-->
          <v-row justify="center" class="my-8">
            <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-responsive min-height="150">
                  <v-expansion-panel-header class="text-h5 fill-height">
                    <v-col cols="4" align="center">
                      <v-img class="mx-8" src="@/assets/oven.jpg" max-width="100"></v-img>
                    </v-col>
                    <v-col cols="8">
                      その他
                    </v-col>
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="text-body-1 py-6">
                  <ul class="explanation__list">
                    <li v-for="(item, index) in otherUsage" :key="index"
                        class="px-4 mb-6"
                        v-html="item"
                    >
                    </li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-container>
        <!--会議室-->
        <v-container pb-12>
          <v-row justify="start">
            <p class="text-h5 my-6">会議室について</p>
          </v-row>
          <v-row justify="center" class="my-8">
            <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-responsive min-height="150">
                  <v-expansion-panel-header class="text-h5 fill-height">
                    <v-col cols="4" align="center">
                      <v-img class="mx-8" src="@/assets/meeting.jpg" max-width="100"></v-img>
                    </v-col>
                    <v-col cols="8">
                      会議室利用ルール
                    </v-col>
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="text-body-1 py-6">
                  <ul class="explanation__list">
                    <li v-for="(item, index) in meetingRoomUsage" :key="`first-${index}`"
                        class="px-4 mb-6"
                        v-html="item"
                    >
                    </li>
                  </ul>
                  <v-img src="@/assets/rule2.jpg" max-width="400" class="mb-6 mx-8"></v-img>
                  <ul class="explanation__list">
                    <li v-for="(item, index) in meetingRoomLightUsage" :key="`second-${index}`"
                        class="px-4 mb-6"
                        v-html="item"
                    >
                    </li>
                  </ul>
                  <v-img src="@/assets/rule3.jpg" max-width="400" class="mb-12 mx-8"></v-img>
                  <p class="mb-6 mx-8"> 照明スイッチ</p>
                  <v-img src="@/assets/rule4.jpg" max-width="400" class="mb-6 mx-8"
                         style="border: black solid"></v-img>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-container>
        <!--ファミレスシート-->
        <v-container pb-12>
          <v-row justify="start">
            <p class="text-h5 my-6">ファミレスシートについて</p>
          </v-row>
          <v-row justify="center" class="my-8">
            <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-responsive min-height="150">
                  <v-expansion-panel-header class="text-h5 fill-height">
                    <v-col cols="4" align="center">
                      <v-img class="mx-8" src="@/assets/famires.jpg" max-width="100"></v-img>
                    </v-col>
                    <v-col cols="8">
                      ファミレスシート利用ルール
                    </v-col>
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="text-body-1 py-6">
                  <ul class="explanation__list">
                    <li v-for="(item, index) in famiResSheetFirstUsage" :key="index"
                        class="px-4 mb-6"
                        v-html="item"
                    >
                    </li>
                    <li class="list__noStyle">
                      <ul class="explanation__detailList">
                        <li v-for="(item, index) in famiResSheetSecondUsage" :key="index"
                            class="px-4 mb-6"
                            v-html="item"
                        >
                        </li>
                      </ul>
                    </li>
                    <li class="px-4">ランチタイム（11時～14時）は社員に開放いたしますので、<span
                        class="d-inline-block">打ち合わせ等はなるべく会議室でお願いいたします。</span></li>
                    <ul class="explanation__detailList py-6">
                      <li v-for="(item, index) in famiResSheetThirdUsage" :key="index"
                          class="px-4 mb-6"
                          v-html="item"
                      >
                      </li>
                    </ul>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-container>
        <!--カレンダー利用状況-->
        <v-container pb-12>
          <v-row justify="start">
            <p class="text-h5 my-6">カレンダー利用状況について</p>
          </v-row>
          <v-row justify="center" width="100%" class="my-8">
            <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-responsive min-height="150">
                  <v-expansion-panel-header class="text-h5 fill-height">
                    <v-col cols="4" align="center">
                      <v-img class="mx-8" src="@/assets/calendar.jpg" max-width="100"></v-img>
                    </v-col>
                    <v-col cols="8">
                      カレンダー利用状況確認方法
                    </v-col>
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="text-body-1 py-6">
                  <ul class="explanation__list">
                    <li class="px-4 mb-6">自分のカレンダーに移動する。
                      <p>
                        <a href="https://www.google.com/calendar" target="_blank">https://www.google.com/calendar</a>
                      </p>
                    </li>
                  </ul>
                  <v-img class="mx-12 my-12" src="@/assets/rule5.jpg" max-width="400"></v-img>
                  <ul class="explanation__list">
                    <li class="px-4 mb-6">カレンダーグループのURL</li>
                  </ul>
                  <v-sheet class="mx-12 pt-3 mb-12 text-body-2" color="rgba(245, 245, 245, 1)" max-width="80%">
                    <p>【神南オフィス】</p>
                    <v-row class="pl-6 mt-3">
                      <v-col cols="3" align="start" class="py-0">MTG 1（10名用・渋谷）</v-col>
                      <v-col cols="9" class="py-0">：medrt.com_36363531383335393539@resource.calendar.google.com
                      </v-col>
                    </v-row>
                    <v-row class="pt-3 pl-6">
                      <v-col cols="3" align="start" class="py-0">MTG 2（6名用・渋谷）</v-col>
                      <v-col cols="9" class="py-0">：medrt.com_2d393338373532353239@resource.calendar.google.com
                      </v-col>
                    </v-row>
                    <v-row class="pt-3 pl-6">
                      <v-col cols="3" align="start" class="py-0">MTG 3（4名用・渋谷）</v-col>
                      <v-col cols="9" class="py-0">
                        ：medrt.com_2d36323233313337392d343939@resource.calendar.google.com
                      </v-col>
                    </v-row>
                    <v-row class="pt-3 pl-6">
                      <v-col cols="3" align="start" class="py-0">ファミレスシート1</v-col>
                      <v-col cols="9" class="py-0">：medrt.com_31373435393533382d373135@resource.calendar.google.com
                      </v-col>
                    </v-row>
                    <v-row class="pt-3 pl-6">
                      <v-col cols="3" align="start" class="py-0">ファミレスシート2</v-col>
                      <v-col cols="9" class="py-0">：medrt.com_2d313635383630382d323232@resource.calendar.google.com
                      </v-col>
                    </v-row>
                    <v-row class="pt-3 pl-6">
                      <v-col cols="3" align="start" class="py-0">ファミレスシート3</v-col>
                      <v-col cols="9" class="py-0">：medrt.com_2d3136343330353032353937@resource.calendar.google.com
                      </v-col>
                    </v-row>
                    <v-row class="pt-3 pl-6">
                      <v-col cols="3" align="start" class="py-0">ファミレスシート4</v-col>
                      <v-col cols="9" class="py-0">：medrt.com_2d3136333437353236313134@resource.calendar.google.com
                      </v-col>
                    </v-row>
                    <v-row class="pt-3 mb-12 pl-6">
                      <v-col cols="3" align="start" class="py-0">セミナールーム</v-col>
                      <v-col cols="9" class="py-0">：medrt.com_2d3632333734313937383336@resource.calendar.google.com
                      </v-col>
                    </v-row>
                    <p>【道玄坂オフィス】</p>
                    <v-row class="pl-6 pb-3 mt-3">
                      <v-col cols="3" align="start" class="py-0">MTG1(道玄坂 8名用)</v-col>
                      <v-col cols="9" class="py-0">：medrt.com_34383139333136383239@resource.calendar.google.com
                      </v-col>
                    </v-row>
                    <v-row class="pl-6 pb-3">
                      <v-col cols="3" align="start" class="py-0">MTG2(道玄坂 4名用)</v-col>
                      <v-col cols="9" class="py-0">：medrt.com_363438323538343733@resource.calendar.google.com</v-col>
                    </v-row>
                  </v-sheet>
                  <ul class="explanation__list">
                    <li class="px-4 mb-6">ファミレスシート番号</li>
                  </ul>
                  <v-img class="mx-12" src="@/assets/rule6.jpg" max-width="400"></v-img>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-container>
        <!--トイレ-->
        <v-container pb-12>
          <v-row justify="start">
            <p class="text-h5 my-6">トイレについて</p>
          </v-row>
          <v-row justify="center" width="100%" class="my-8">
            <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-responsive min-height="150">
                  <v-expansion-panel-header class="text-h5 fill-height">
                    <v-col cols="4" align="center">
                      <v-img class="mx-8" src="@/assets/toilet.jpg" max-width="100"></v-img>
                    </v-col>
                    <v-col cols="8">
                      トイレ利用ルール
                    </v-col>
                  </v-expansion-panel-header>
                </v-responsive>
                <v-expansion-panel-content class="text-body-1">
                  <ul class="explanation__list">
                    <li v-for="(item, index) in toiletUsage" :key="index"
                        class="px-4 mb-6"
                        v-html="item"
                    >
                    </li>
                  </ul>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-container>
      </v-container>
    </v-sheet>
  </v-main>
</template>

<script>
import Title from '../components/Title';

export default {
  name: 'RuleView',
  components: {
    Title,
  },
  data() {
    return {
      title: 'オフィス内設備使用ルール',
      img: 'title_rule.svg',

      // 冷蔵庫利用について
      refrigeratorUsage: [
        `<span class="text-decoration-underline">毎週金曜日の夕方（休みの際は前倒し）に冷蔵庫棚卸を行い、</span><span
            class="d-inline-block text-decoration-underline">以下のルールが守られていないものは</span><span
            class="d-inline-block text-decoration-underline">全て処分します！</span>`,
        `<span class="text-decoration-underline">その日に食べる物、</span><span class="d-inline-block text-decoration-underline">飲む物のみ利用OKとします。</span>
            <span class="d-inline-block">置き弁置き飲み物禁止です。</span>`,
        `しまう際は必ず、<span
            class="d-inline-block text-decoration-underline">名前と日付をマジックで書いてください。</span>記入されていないものは即処分となります。<span
            class="d-inline-block">ニックネームでOK！</span>`,
        `<span class="text-decoration-underline">マイ調味料（ドレッシング、しょうゆ、マヨネーズ）を</span><span
                      class="d-inline-block text-decoration-underline">置く事は禁止します。</span>`,
        `衛生面の観点から、<span class="d-inline-block text-decoration-underline">飲みかけ、</span><span
                      class="d-inline-block text-decoration-underline">食べかけの物は入れないようお願いします。</span>`,
        `社内イベントやセミナーで冷蔵庫を大きく占有する際は、<span
                      class="d-inline-block">総務チームまで一声かけていただくようお願いします。</span>`,
        `誤って冷蔵庫を汚してしまった際は、<span class="d-inline-block">冷蔵庫上のアルコールスプレーとダスターで掃除し、</span><span
                      class="d-inline-block">ダスターは水洗いしてシンクの上に置いてください。</span>（定期的に消毒します）`,
      ],
      dumpSiteUsage: [
        `ゴミ捨て場は2か所あります。<span class="d-inline-block">給湯室はすぐいっぱいになります。</span><span
                      class="d-inline-block">どちらもご利用ください。</span>`,
        'ゴミは極力持ち帰りましょう。<span class="d-inline-block">回収できる量に限りがあります。</span>',
        '分別の徹底をお願いします。<span class="d-inline-block">※詳しい分別方法はゴミ捨て場の壁の掲示物を見てください。</span>',
        'ペットボトルはフィルムを剥がし、<span class="d-inline-block">キャップはキャップ用のゴミ箱へ捨ててください。</span>',
        '回収できるゴミは、<span class="d-inline-block text-decoration-underline">燃えるゴミ・ペットボトル・びん・缶のみとなります。</span>',
        'キャップ用ゴミ箱は「ペットボトルキャップ専用」です。<span class="d-inline-block">それ以外のキャップは燃えるゴミへお願いします。</span>',
        'ゴミ箱がいっぱいになっていたら持ち帰りましょう。<span class="d-inline-block">回収できる量には限りがあります。</span>',
        'スプレー缶や電池等の特殊なゴミは回収しません。<span class="d-inline-block">ゴミ捨て場に放置しないでください。</span><span class="d-inline-block">（会社備品の場合ご相談ください。）</span>',
        '食べ残しや空になったお弁当の容器は袋に入れ、<span class="d-inline-block">しっかりと縛って捨ててください。</span>',
        '飲み残しは流し台へ捨て、<span class="d-inline-block">中を軽くすすいでから捨ててください。</span>',
      ],
      dumpSiteCautionUsage: [
        'ペットボトルのゴミ箱に<span class="d-inline-block">コンビニの袋に入ったお弁当容器が捨てられていた</span>',
        '飲み物がまだ残った状態のペットボトルが捨てられていた',
        '空のお弁当容器や食べ残しが<span class="d-inline-block">そのままゴミ箱へ入っていて異臭がしていた</span>',
        '食べ残し・飲み残しが飛び散り、<span class="d-inline-block">ゴミ箱が汚れている・つぶれている</span>',
        'ゴミ箱の容量を超えるゴミを<span class="d-inline-block">無理やり詰め込みゴミ箱がつぶれている</span>',
        '流し台にマグカップが置かれており、<span class="d-inline-block">清掃の邪魔になっている</span>',
        '冷蔵庫に飲み物がこぼれたまま放置<span class="d-inline-block">（親切な方が掃除してくれました。ありがとう。）</span>',
        '冷蔵庫に賞味期限切れ食料や、<span class="d-inline-block">飲み口が空いたままの飲み物が放置されている</span><span class="d-inline-block">（緑色のカビまみれのプリンやお弁当を何回も捨てています）</span>',
      ],
      otherUsage: [
        '流し台横、電子レンジの前は共有スペースです。<span class="d-inline-block">タンブラーやマグカップを放置しないようお願いします。</span>',
        '電子レンジの中を汚してしまった場合、<span class="d-inline-block">アルコールスプレーとダスターできれいに掃除してください。</span>',
      ],
      meetingRoomUsage: [
        '原則として、会議室の利用は、<span class="d-inline-block">社外打ち合わせを優先し、</span><span class="d-inline-block">社内の打ち合わせはファミレスシートをご利用ください。</span>',
        '利用前に、Googleカレンダーにて予約をお願いいたします。',
        '基本的に先着順となります。',
        '予約時間は、事前準備・後片付けも含めた時間でご登録いただき、<span class="d-inline-block">予約終了時間には会議室が利用できる状態にしてください。</span>',
        'カギはかけておりません。そのままご利用ください。',
        '予約時には、区分（来客or社内）の記入と、<span class="d-inline-block">打ち合わせ内容を記入してください。</span>',
        '会議室の利用は、来客が優先となりますので、<span class="d-inline-block">判断基準とさせていただきます。</span><p class="mt-6">予約例）</p>',
      ],
      meetingRoomLightUsage: [
        '照明の操作をお願いいたします。',
        '会議室の照明は節電の為に常に消しておりますので、<span class="d-inline-block">利用時の点灯、利用後の消灯をお願いいたします。</span><span class="d-inline-block">照明のスイッチは受付からエントランスに入って左手にございます。</span>',
        '後片付けをお願いいたします。',
        'テーブルの清掃（台拭きは冷蔵庫の上にあります）椅子の整頓等、<span class="d-inline-block">次に利用する方がそのまま使用できる環境に整えてから退室してください。</span>',
        '利用後は会議室のドアは開放してください。',
      ],
      famiResSheetFirstUsage: [
        '利用前に、Googleカレンダーにて予約をお願いいたします。',
        '予約時には、区分（来客or社内）の記入と、<span class="d-inline-block">打ち合わせ内容を記入してください。</span>',
      ],
      famiResSheetSecondUsage: [
        '2名以上の打ち合わせでご利用ください。',
        'フリーアドレスは執務室内のみのため、<span class="d-inline-block">1名での利用はご遠慮ください。</span>',
      ],
      famiResSheetThirdUsage: [
        'ランチで利用する場合は、<span class="d-inline-block">予約の必要はございません。</span>',
        'お客様もいらっしゃいますので、<span class="d-inline-block">昼寝等はご遠慮ください。</span>',
        '使用後の後片付け（台拭き等）をお願いいたします。',
      ],
      toiletUsage: [
        'トイレットペーパーが無くなりそうな時は<span class="d-inline-block">皆で協力して交換してください。</span><span class="d-inline-block">洗面台下にあります。</span><span class="d-inline-block">無ければ日本メディカルキャリアの執務室に在庫があります。</span>',
        '洗面台がよく水びたしになっています。<span class="d-inline-block">雑巾やダスターで拭いてください。</span>',
        '女子トイレの洗面台や床によく髪の毛が落ちています。<span class="d-inline-block">落としたらペーパーで集めてゴミ箱へ捨てる等ご協力ください。</span>',
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.v-expansion-panels {
  border: 2px solid #ffffff;
  border-radius: 4px;

  &:hover {
    border: 2px solid #0095D9;
    border-radius: 4px;
  }
}

.v-expansion-panel--active {
  border: 2px solid #0095D9;
  border-radius: 4px;
}

.explanation__list li {
  position: relative;
  list-style: none;

  &:before {
    content: '';
    width: 10px;
    height: 1px;
    background-color: #d70e19;
    position: absolute;
    top: 10px;
    left: 0;
  }
}

.explanation__detailList li {
  list-style: unset;

  &:before {
    display: none;
  }
}

.dumpSite__img {
  border: 1.25px solid black;
}

.explanation__list {
  .list__noStyle {
    &:before {
      content: '';
      width: 0;
      height: 0;
    }
  }
}
</style>